import NotFoundSection from "@/app/components/NotFoundSection";
import { NotFoundHelmet } from "@/app/(public)/_seo/PublicLayoutMetadata";

export default function NotFoundPage() {
  return (
    <>
      <NotFoundHelmet />
      <NotFoundSection ctaLabel="Back to Home" ctaHref="/" />
    </>
  );
}
